import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Youtube } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

// TikTok icon (not in lucide-react)
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
  </svg>
);

const socialLinks = [
  { id: 'facebook', label: 'Facebook', icon: Facebook, placeholder: 'URL do Facebook' },
  { id: 'twitter', label: 'Twitter/X', icon: Twitter, placeholder: 'URL do Twitter' },
  { id: 'linkedin', label: 'LinkedIn', icon: Linkedin, placeholder: 'URL do LinkedIn' },
  { id: 'instagram', label: 'Instagram', icon: Instagram, placeholder: 'URL do Instagram' },
  { id: 'youtube', label: 'Youtube', icon: Youtube, placeholder: 'URL do Youtube' },
  { id: 'tiktok', label: 'TikTok', icon: TikTokIcon, placeholder: 'URL do TikTok' },
];

const Step3SocialLinks = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const isValidUrl = (url) => {
    if (!url) return true;
    try {
      new URL(url.startsWith('http') ? url : `https://${url}`);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <p className="text-slate-600">Adicione os links das suas redes sociais. Apenas as preenchidas serão exibidas na assinatura.</p>
      </div>
      
      <div className="space-y-4">
        {socialLinks.map(({ id, label, icon: Icon, placeholder }) => {
          const value = data[id];
          const isValid = isValidUrl(value);
          
          return (
            <div key={id} className="space-y-2">
              <Label htmlFor={id} className="flex items-center gap-2 text-slate-700">
                <Icon className="w-4 h-4" />
                {label}
              </Label>
              <Input
                id={id}
                type="url"
                placeholder={placeholder}
                value={value}
                onChange={(e) => handleChange(id, e.target.value)}
                className={`transition-all duration-200 focus:ring-2 focus:ring-blue-500/20 ${
                  value && !isValid ? 'border-red-400 focus:ring-red-500/20' : ''
                }`}
              />
              {value && !isValid && (
                <p className="text-xs text-red-500">URL inválida</p>
              )}
            </div>
          );
        })}      </div>
    </div>
  );
};

export default Step3SocialLinks;
